var _style, _path, _path2, _line, _line2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilisationDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FF0000;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.957,401.043c12.997-16.453,20.523-36.576,21.522-57.54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.043,401.043c-12.997-16.453-20.523-36.576-21.522-57.54"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 185.42,
    y1: 401.043,
    x2: 314.551,
    y2: 401.043
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 85,
    y1: 300.348,
    x2: 415,
    y2: 300.348
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.348,98.957h301.304c7.924,0,14.348,6.44,14.348,14.385v215.775c0,7.945-6.424,14.385-14.348,14.385H99.348 c-7.924,0-14.348-6.44-14.348-14.385V113.342C85,105.398,91.424,98.957,99.348,98.957z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.034,260.419v-35.472c0-2.177-1.76-3.941-3.931-3.941h-15.724c-2.171,0-3.931,1.765-3.931,3.941v35.472"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.207,260.419v-74.884c0-2.177-1.76-3.941-3.931-3.941h-15.724c-2.171,0-3.931,1.765-3.931,3.941v74.884"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.38,260.419V201.3c0-2.177-1.76-3.941-3.931-3.941h-15.724c-2.171,0-3.931,1.765-3.931,3.941v59.119"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.553,260.419V146.122c0-2.177-1.76-3.941-3.931-3.941h-15.724c-2.171,0-3.931,1.765-3.931,3.941v114.297"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.585,260.419h180.831"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilisationDashboardIcon);
export default __webpack_public_path__ + "static/media/utilisation-dashboard-icon.6ea033aaeb4c270e0cd25124eb7d0574.svg";
export { ForwardRef as ReactComponent };